import { useTranslation } from 'react-i18next';
import { DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { useDeactivateAccount } from '../../../hooks/use-account';

interface DeactivateAccountProps {
    onClose: () => void;
}
/// Its deletes the account parmanently
export const DeactivateAccount = ({ onClose }: DeactivateAccountProps) => {
    const { t } = useTranslation();
    const { mutate: deactivateAccount, isPending } = useDeactivateAccount({ isDeleteForever: true });

    const handleDeactivate = () => {
        deactivateAccount(undefined, {
            onSuccess: () => {
                onClose();
            },
        });
    };

    return (
        <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle className="text-destructive">{t('DELETE_ACCOUNT')}</DialogTitle>
                <DialogDescription className="text-medium-emphasis">
                    {t('DELETE_ACCOUNT_WARNING')} {t('YOU_WILL_BE_LOGGED_OUT_AFTER_DELETION')}


                </DialogDescription>
            </DialogHeader>
            <DialogFooter>
                <Button
                    variant="ghost"
                    onClick={onClose}
                    className="text-medium-emphasis hover:text-high-emphasis"
                >
                    {t('CANCEL')}
                </Button>
                <Button
                    variant="destructive"
                    onClick={handleDeactivate}
                    disabled={isPending}
                >
                    {isPending ? t('DELETING') : t('DELETE_ACCOUNT')}
                </Button>
            </DialogFooter>
        </DialogContent>
    );
}; 